/*
  LAB behangcalculator, interface.
  Verwacht dat behang-calculator.js al geladen is (window.LABBehangCalc).
  Wordt gebruikt als custom element <behang-calculator> met een JSON-configuratie
  als eerste kind. Zie sections/behang-calculator.liquid.
*/
(function () {
  'use strict';

  var CORE = window.LABBehangCalc;
  if (!CORE) return;

  var SAMPLE_RX = /staal|stalen|sample|monster|swatch|proefstuk/i;

  function nl(n, decimals) {
    var d = decimals === undefined ? 2 : decimals;
    return Number(n || 0).toFixed(d).replace('.', ',');
  }

  function esc(s) {
    return String(s === null || s === undefined ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function plural(n, one, many) {
    return n === 1 ? one : many;
  }

  // Kilo's uit een varianttitel halen, bijvoorbeeld "5 kilo" of "15 kg".
  function kgFromTitle(title) {
    var m = String(title || '').match(/(\d+(?:[.,]\d+)?)\s*(kg|kilo)/i);
    return m ? parseFloat(m[1].replace(',', '.')) : 0;
  }

  function Calculator(host, config) {
    this.host = host;
    this.cfg = config || {};
    this.settings = this.cfg.settings || {};
    this.product = this.cfg.product || {};
    this.meta = this.cfg.metafields || {};

    this.glueVariants = ((this.cfg.glue && this.cfg.glue.variants) || [])
      .map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: parseFloat(v.price) || 0,
          kg: kgFromTitle(v.title)
        };
      })
      .filter(function (v) { return v.kg > 0; })
      .sort(function (a, b) { return b.kg - a.kg; });

    this.walls = [{ width: '', height: '' }];
    this.profileKey = CORE.PROFILES[this.settings.profile_default] ? this.settings.profile_default : 'pro';
    this.override = {};
    this.extras = { glue: true, kit: true };
    this.contact = {};
    this.projectsOpen = false;
    this.result = null;
    this.spec = null;
    this.busy = false;

    this.restored = false;
    this.build();
    // Eerst de link, die is het meest specifiek. Staat daar niets in, dan wat de
    // klant eerder in deze browser heeft ingevuld.
    if (!this.restoreFromUrl()) this.restored = this.restore();
    this.render();
    this.watchVariant();
  }

  // Een ander behang in dezelfde calculator laden. De muren, het profiel en de
  // gegevens van de klant blijven staan, alleen het product wisselt. Gebruikt
  // door de losse pagina waar je eerst een behang zoekt.
  Calculator.prototype.loadProduct = function (cfg) {
    cfg = cfg || {};
    this.cfg = Object.assign({}, this.cfg, cfg);
    this.product = cfg.product || {};
    this.meta = cfg.metafields || {};
    if (cfg.settings) this.settings = cfg.settings;

    this.glueVariants = (((cfg.glue || this.cfg.glue || {}).variants) || [])
      .map(function (v) {
        return {
          id: v.id,
          title: v.title,
          available: v.available !== false,
          price: parseFloat(v.price) || 0,
          kg: kgFromTitle(v.title)
        };
      })
      .filter(function (v) { return v.kg > 0; })
      .sort(function (a, b) { return b.kg - a.kg; });

    // Een nieuw product betekent een nieuwe specificatie, dus de handmatige
    // aanpassingen van het vorige product gaan eraf.
    this.override = {};
    this.specOpen = undefined;
    this.busy = false;
    this.restored = false;

    this.render();
    if (this.projectsOpen) this.refreshMail();
  };

  Calculator.prototype.profile = function () {
    return CORE.PROFILES[this.profileKey] || CORE.PROFILES.pro;
  };

  // Specificatie uit de metafields, daarna de handmatige aanpassingen eroverheen.
  Calculator.prototype.buildSpec = function (profile) {
    var pr = profile || this.profile();
    var spec = CORE.buildSpec({
      vendor: this.product.vendor,
      afmeting: this.meta.afmeting,
      aanzet: this.meta.aanzet,
      aanzetsimpel: this.meta.aanzetsimpel,
      lijm: this.meta.lijm,
      waste: pr.waste,
      coverage_per_kg: parseFloat(this.settings.glue_coverage) || CORE.DEFAULTS.coverage_per_kg
    });

    this.autoSpec = spec;

    var o = this.override;
    var merged = Object.assign({}, spec);
    if (o.mode) merged.mode = o.mode;
    if (o.roll_width > 0) merged.roll_width = o.roll_width;
    if (o.roll_length > 0) merged.roll_length = o.roll_length;
    if (o.panel_width > 0) merged.panel_width = o.panel_width;
    if (o.panel_height > 0) merged.panel_height = o.panel_height;
    if (o.pattern_type) merged.pattern_type = o.pattern_type;
    if (o.repeat !== undefined) merged.repeat = o.repeat;
    if (o.offset !== undefined) merged.offset = o.offset;
    if (o.waste !== undefined) merged.waste = o.waste;
    if (o.coverage > 0) merged.coverage_per_kg = o.coverage;

    // Bij een handmatige aanpassing verdwijnen de meldingen over onbekende maten.
    if (Object.keys(o).length) {
      merged.warnings = merged.warnings.filter(function (w) {
        return ['muur-hoger-dan-paneel', 'op-maat'].indexOf(w) !== -1;
      });
    }
    if (merged.pattern_type === 'random') { merged.repeat = 0; merged.offset = 0; }
    if (merged.pattern_type === 'half_drop' && merged.repeat > 0 && !merged.offset) {
      merged.offset = merged.repeat / 2;
    }
    merged.complete = CORE.isComplete(merged);
    return merged;
  };

  Calculator.prototype.build = function () {
    var s = this.settings;
    var heading = s.heading || 'Behangcalculator';
    var intro = s.intro || '';

    this.host.innerHTML =
      '<div class="bcalc">' +
        '<div class="bcalc__head">' +
          (s.eyebrow ? '<p class="bcalc__eyebrow">' + esc(s.eyebrow) + '</p>' : '') +
          '<h2 class="bcalc__title">' + esc(heading) + '</h2>' +
          (intro ? '<p class="bcalc__intro">' + intro + '</p>' : '') +
        '</div>' +

        '<div data-notices></div>' +

        '<div class="bcalc__block">' +
          '<div class="bcalc__block-head">' +
            '<h3 class="bcalc__block-title">Dit behang</h3>' +
            '<span class="bcalc__block-note" data-spec-note></span>' +
          '</div>' +
          '<div class="bcalc__block-body">' +
            '<ul class="bcalc__chips" data-chips></ul>' +
            '<button type="button" class="bcalc__linkbtn" data-toggle-spec>Maten zelf invullen</button>' +
            '<div class="bcalc__grid bcalc__hidden" data-spec-form></div>' +
          '</div>' +
        '</div>' +

        '<div class="bcalc__block">' +
          '<div class="bcalc__block-head">' +
            '<h3 class="bcalc__block-title">Muren</h3>' +
            '<span class="bcalc__block-note">Maten in meter</span>' +
          '</div>' +
          '<div class="bcalc__block-body">' +
            '<div data-walls></div>' +
            '<button type="button" class="bcalc__addwall" data-add-wall>Muur toevoegen</button>' +
          '</div>' +
        '</div>' +

        '<div class="bcalc__block">' +
          '<div class="bcalc__block-head">' +
            '<h3 class="bcalc__block-title">Wie gaat behangen</h3>' +
            '<span class="bcalc__block-note">Bepaalt snijverlies en reserve</span>' +
          '</div>' +
          '<div class="bcalc__block-body">' +
            '<div class="bcalc__profiles" data-profiles></div>' +
            (s.caution ? '<div class="bcalc__caution">' + s.caution + '</div>' : '') +
          '</div>' +
        '</div>' +

        '<div class="bcalc__block bcalc__result" data-result></div>' +

        this.projectsHtml() +

        (s.footnote ? '<p class="bcalc__foot">' + s.footnote + '</p>' : '') +
      '</div>';

    var self = this;
    this.host.addEventListener('click', function (e) {
      var t = e.target.closest('[data-add-wall],[data-remove-wall],[data-toggle-spec],[data-add-cart],[data-add-sample],[data-copy-link],[data-print],[data-forget],[data-projects],[data-mail-copy]');
      if (!t) return;
      if (t.hasAttribute('data-add-wall')) {
        self.walls.push({ width: '', height: '' });
        self.renderWalls(); self.update();
      } else if (t.hasAttribute('data-remove-wall')) {
        if (self.walls.length > 1) self.walls.splice(+t.getAttribute('data-remove-wall'), 1);
        self.renderWalls(); self.update();
      } else if (t.hasAttribute('data-toggle-spec')) {
        self.specOpen = !self.specOpen;
        self.renderSpec();
      } else if (t.hasAttribute('data-add-cart')) {
        self.addToCart();
      } else if (t.hasAttribute('data-add-sample')) {
        self.addSample();
      } else if (t.hasAttribute('data-copy-link')) {
        self.copyLink(t);
      } else if (t.hasAttribute('data-print')) {
        self.print();
      } else if (t.hasAttribute('data-forget')) {
        self.forget();
      } else if (t.hasAttribute('data-projects')) {
        self.toggleProjects();
      } else if (t.hasAttribute('data-mail-copy')) {
        self.copyMail(t);
      }
    });

    this.host.addEventListener('input', function (e) {
      var el = e.target;
      if (el.hasAttribute('data-wall')) {
        var p = el.getAttribute('data-wall').split(':');
        self.walls[+p[0]][p[1]] = el.value === '' ? '' : parseFloat(el.value);
        self.update();
      } else if (el.hasAttribute('data-spec')) {
        self.readSpecForm();
      } else if (el.hasAttribute('data-contact')) {
        self.contact[el.getAttribute('data-contact')] = el.value;
        self.refreshMail();
      }
    });

    this.host.addEventListener('change', function (e) {
      var el = e.target;
      if (el.hasAttribute('data-profile')) {
        self.profileKey = el.value;
        self.renderProfiles();
        self.update();
      } else if (el.hasAttribute('data-spec')) {
        self.readSpecForm();
        // Alleen bij een keuzelijst het formulier opnieuw opbouwen. Bij een
        // getalveld zou dat het veld onder de handen van de klant vervangen.
        if (el.tagName === 'SELECT') self.renderSpecForm();
      } else if (el.hasAttribute('data-extra')) {
        self.extras[el.getAttribute('data-extra')] = el.checked;
      } else if (el.hasAttribute('data-contact')) {
        self.contact[el.getAttribute('data-contact')] = el.value;
        self.refreshMail();
      }
    });
  };

  /* ---------------- productspecificatie ---------------- */

  Calculator.prototype.renderChips = function () {
    var spec = this.spec;
    var chips = [];
    chips.push('<li class="bcalc__chip"><b>' + esc(CORE.MODE_LABEL[spec.mode] || spec.mode) + '</b></li>');

    if (spec.mode === 'panel' || spec.mode === 'tile') {
      if (spec.panel_width) chips.push('<li class="bcalc__chip">Breedte ' + nl(spec.panel_width * 100, 1) + ' cm</li>');
      if (spec.panel_height) chips.push('<li class="bcalc__chip">Hoogte ' + nl(spec.panel_height * 100, 1) + ' cm</li>');
      if (spec.pack_panels > 1) chips.push('<li class="bcalc__chip">' + spec.pack_panels + ' banen per set</li>');
    } else {
      if (spec.roll_width) chips.push('<li class="bcalc__chip">Baanbreedte ' + nl(spec.roll_width * 100, 1) + ' cm</li>');
      if (spec.mode === 'roll' && spec.roll_length) chips.push('<li class="bcalc__chip">Rol ' + nl(spec.roll_length) + ' m</li>');
      chips.push('<li class="bcalc__chip">' + esc(CORE.PATTERN_LABEL[spec.pattern_type]) + (spec.repeat ? ' ' + nl(spec.repeat * 100, 1) + ' cm' : '') + '</li>');
      if (spec.pattern_type === 'half_drop' && spec.offset) chips.push('<li class="bcalc__chip">Verspringing ' + nl(spec.offset * 100, 1) + ' cm</li>');
    }
    if (spec.glue_text) chips.push('<li class="bcalc__chip bcalc__chip--soft">' + esc(spec.glue_text) + '</li>');

    this.host.querySelector('[data-chips]').innerHTML = chips.join('');
    this.host.querySelector('[data-spec-note]').textContent = this.product.title || '';
  };

  Calculator.prototype.renderSpec = function () {
    var form = this.host.querySelector('[data-spec-form]');
    var btn = this.host.querySelector('[data-toggle-spec]');
    // Bij een onbekende maat staat het formulier meteen open.
    if (this.specOpen === undefined) this.specOpen = !this.spec.complete;
    form.classList.toggle('bcalc__hidden', !this.specOpen);
    btn.textContent = this.specOpen ? 'Maten dichtklappen' : 'Maten zelf invullen';
    if (this.specOpen) this.renderSpecForm();
  };

  Calculator.prototype.renderSpecForm = function () {
    var spec = this.spec;
    var form = this.host.querySelector('[data-spec-form]');
    if (form.classList.contains('bcalc__hidden')) return;

    function field(label, name, value, step) {
      return '<div class="bcalc__field"><label class="bcalc__label" for="bc-' + name + '">' + label + '</label>' +
        '<input type="number" id="bc-' + name + '" data-spec="' + name + '" value="' + (value || '') + '" min="0" step="' + (step || '0.1') + '" inputmode="decimal"></div>';
    }
    function select(label, name, value, options) {
      return '<div class="bcalc__field"><label class="bcalc__label" for="bc-' + name + '">' + label + '</label>' +
        '<select id="bc-' + name + '" data-spec="' + name + '">' +
        options.map(function (o) {
          return '<option value="' + o[0] + '"' + (o[0] === value ? ' selected' : '') + '>' + o[1] + '</option>';
        }).join('') + '</select></div>';
    }

    // Bij een onbekende of op maat gemaakte afmeting begint het formulier bij
    // een rol, dat is het meest voorkomende geval.
    var formMode = (spec.mode === 'roll' || spec.mode === 'lm' || spec.mode === 'panel' || spec.mode === 'tile')
      ? spec.mode
      : 'roll';

    var html = select('Verkoopwijze', 'mode', formMode, [
      ['roll', 'Per rol'],
      ['lm', 'Per lopende meter'],
      ['panel', 'Paneel of panorama'],
      ['tile', 'Tegels']
    ]);

    if (formMode === 'panel' || formMode === 'tile') {
      html += field('Breedte (cm)', 'panel_width', spec.panel_width ? CORE.round2(spec.panel_width * 100) : '', '0.1');
      html += field('Hoogte (cm)', 'panel_height', spec.panel_height ? CORE.round2(spec.panel_height * 100) : '', '0.1');
    } else {
      html += field('Baanbreedte (cm)', 'roll_width', spec.roll_width ? CORE.round2(spec.roll_width * 100) : '', '0.1');
      if (formMode === 'roll') html += field('Rollengte (m)', 'roll_length', spec.roll_length ? CORE.round2(spec.roll_length) : '', '0.05');
      html += select('Aanzet', 'pattern_type', spec.pattern_type, [
        ['random', 'Vrije aanzet'],
        ['straight', 'Rechte aanzet'],
        ['half_drop', 'Verspringende aanzet']
      ]);
      if (spec.pattern_type !== 'random') {
        html += field('Patroonherhaling (cm)', 'repeat', spec.repeat ? CORE.round2(spec.repeat * 100) : '', '0.1');
      }
      if (spec.pattern_type === 'half_drop') {
        html += field('Verspringing (cm)', 'offset', spec.offset ? CORE.round2(spec.offset * 100) : '', '0.1');
      }
      html += field('Snijverlies per baan (cm)', 'waste', CORE.round2(spec.waste * 100), '1');
    }
    html += field('Dekking per kilo lijm (m²)', 'coverage', CORE.round2(spec.coverage_per_kg), '0.5');

    form.innerHTML = html;
  };

  Calculator.prototype.readSpecForm = function () {
    var form = this.host.querySelector('[data-spec-form]');
    var o = {};
    Array.prototype.forEach.call(form.querySelectorAll('[data-spec]'), function (el) {
      var name = el.getAttribute('data-spec');
      if (el.tagName === 'SELECT') { o[name] = el.value; return; }
      if (el.value === '') return;
      var v = parseFloat(el.value);
      if (!isFinite(v)) return;
      if (['roll_width', 'panel_width', 'panel_height', 'repeat', 'offset', 'waste'].indexOf(name) !== -1) {
        o[name] = v / 100;
      } else {
        o[name] = v;
      }
    });
    this.override = o;
    this.update();
  };

  /* ---------------- muren ---------------- */

  Calculator.prototype.renderWalls = function () {
    var host = this.host.querySelector('[data-walls]');
    var many = this.walls.length > 1;
    host.innerHTML = this.walls.map(function (wall, i) {
      return '' +
        '<div class="bcalc__wall">' +
          '<div class="bcalc__wall-row">' +
            '<span class="bcalc__wall-name">Muur ' + (i + 1) + '</span>' +
            '<input type="number" data-wall="' + i + ':width" value="' + (wall.width === '' ? '' : wall.width) + '" placeholder="Breedte (m)" min="0" step="0.1" inputmode="decimal">' +
            '<span class="bcalc__wall-x">×</span>' +
            '<input type="number" data-wall="' + i + ':height" value="' + (wall.height === '' ? '' : wall.height) + '" placeholder="Hoogte (m)" min="0" step="0.1" inputmode="decimal">' +
            '<span class="bcalc__wall-area" data-area="' + i + '"></span>' +
            (many
              ? '<button type="button" class="bcalc__iconbtn" data-remove-wall="' + i + '" aria-label="Muur verwijderen">×</button>'
              : '<span class="bcalc__iconbtn bcalc__iconbtn--ghost"></span>') +
          '</div>' +
        '</div>';
    }).join('');
    this.renderAreas();
  };

  Calculator.prototype.renderAreas = function () {
    var self = this;
    this.walls.forEach(function (wall, i) {
      var w = parseFloat(wall.width) || 0;
      var h = parseFloat(wall.height) || 0;
      var cell = self.host.querySelector('[data-area="' + i + '"]');
      if (!cell) return;
      cell.textContent = (w > 0 && h > 0) ? '= ' + nl(w * h) + ' m²' : '';
    });
  };

  /* ---------------- profiel ---------------- */

  Calculator.prototype.renderProfiles = function () {
    var self = this;
    var host = this.host.querySelector('[data-profiles]');
    host.innerHTML = Object.keys(CORE.PROFILES).map(function (key) {
      var p = CORE.PROFILES[key];
      var on = key === self.profileKey;
      return '' +
        '<label class="bcalc__profile' + (on ? ' bcalc__profile--on' : '') + '">' +
          '<input type="radio" name="bcalc-profile" data-profile value="' + key + '"' + (on ? ' checked' : '') + '>' +
          '<span class="bcalc__profile-name">' + esc(p.label) + '</span>' +
          '<span class="bcalc__profile-note">' + esc(p.note) + '</span>' +
          '<span class="bcalc__profile-marge" data-profile-marge="' + key + '">' +
            nl(p.waste * 100, 0) + ' cm snijverlies' +
          '</span>' +
          '<span class="bcalc__profile-uitkomst" data-profile-uitkomst="' + key + '"></span>' +
        '</label>';
    }).join('');
    this.refreshProfiles();
  };

  // Zet op elk kaartje wat dat profiel voor deze muren oplevert. Anders is het
  // gokken wat de keuze doet.
  Calculator.prototype.refreshProfiles = function () {
    var self = this;
    Object.keys(CORE.PROFILES).forEach(function (key) {
      var p = CORE.PROFILES[key];
      var marge = self.host.querySelector('[data-profile-marge="' + key + '"]');
      var uit = self.host.querySelector('[data-profile-uitkomst="' + key + '"]');
      if (!marge || !uit) return;

      var bundle = self.computeFor(key);
      var r = bundle.result;
      var reserve = r && r.valid
        ? (r.extra_strips === 0
            ? 'geen reservebaan'
            : r.extra_strips + (r.extra_strips === 1 ? ' baan reserve' : ' banen reserve'))
        : p.buffer + '% reserve';

      marge.textContent = nl(p.waste * 100, 0) + ' cm snijverlies, ' + reserve;
      uit.textContent = (r && r.valid && r.units_recommended > 0)
        ? r.units_recommended + ' ' + (r.units_recommended === 1 ? r.unit : r.unit_plural)
        : '';
    });
  };

  /* ---------------- meldingen ---------------- */

  Calculator.prototype.renderNotices = function () {
    var host = this.host.querySelector('[data-notices]');
    var list = CORE.unique((this.spec.warnings || []).concat((this.result && this.result.warnings) || []));
    var texts = list
      .filter(function (w) { return w !== 'geen-muren'; })
      .map(function (w) { return CORE.WARNING_TEXT[w] || w; });
    host.innerHTML = CORE.unique(texts).map(function (t) {
      return '<div class="bcalc__notice">' + esc(t) + '</div>';
    }).join('');
  };

  /* ---------------- resultaat ---------------- */

  Calculator.prototype.renderResult = function () {
    var host = this.host.querySelector('[data-result]');
    var r = this.result;
    var spec = this.spec;

    if (!r || !r.valid || r.units_recommended <= 0) {
      host.innerHTML =
        '<div class="bcalc__block-head"><h3 class="bcalc__block-title">Resultaat</h3></div>' +
        '<div class="bcalc__block-body"><p class="bcalc__intro" style="margin:0">' +
        (spec.complete ? 'Vul de breedte en hoogte van je muur in.' : 'Vul eerst de maten van het behang aan.') +
        '</p></div>';
      return;
    }

    var unit = r.units_recommended === 1 ? r.unit : r.unit_plural;
    var isPanel = spec.mode === 'panel' || spec.mode === 'tile';
    var rows = [];

    rows.push(['Oppervlak', nl(r.net_m2) + ' m²']);

    if (isPanel) {
      rows.push(['Aantal banen nodig', String(r.strips)]);
    } else {
      rows.push(['Aantal banen', String(r.strips)]);
      rows.push(['Baanlengte', r.cut_lengths.map(function (c) { return nl(c); }).join(' en ') + ' m']);
      // Laat zien hoeveel er per baan overblijft om uit te lijnen en te snijden.
      // Bij een patroon is dat meer dan het snijverlies van het profiel, want de
      // baan wordt afgerond op hele patroonherhalingen.
      rows.push([
        'Over voor uitlijnen',
        (r.trim_min === r.trim_max
          ? nl(r.trim_min * 100, 0) + ' cm'
          : nl(r.trim_min * 100, 0) + ' tot ' + nl(r.trim_max * 100, 0) + ' cm') + ' per baan',
        true
      ]);
      rows.push(['Te snijden lengte', nl(r.total_length_m) + ' m', true]);
      if (spec.mode === 'roll' && r.strips_per_roll > 0) {
        rows.push(['Banen per rol', String(r.strips_per_roll), true]);
        // Bij een patroon wordt elke baan afgerond op hele patroonherhalingen,
        // zodat de volgende baan uit dezelfde rol weer goed begint. De laatste
        // baan uit een rol hoeft dat niet, en juist daardoor past hij er nog bij.
        if (r.short_last_gain) {
          rows.push([
            'Laatste baan per rol',
            nl(r.cut_last) + ' m in plaats van ' + nl(r.cut_max) + ' m',
            true
          ]);
        }
      }
    }

    if (r.extra_strips === 0 && !isPanel) {
      rows.push(['Reserve', 'geen extra baan, dit profiel rekent krap', true]);
    } else if (r.extra_strips > 0) {
      rows.push([
        'Reserve',
        r.extra_strips + (r.extra_strips === 1 ? ' extra baan' : ' extra banen') +
          (r.extra_units > 0
            ? ', dus ' + nl(r.extra_units, 0) + ' ' + (r.extra_units === 1 ? r.unit : r.unit_plural) + ' erbij'
            : ', past nog in wat je toch al hebt'),
        true
      ]);
    } else if (spec.mode === 'panel') {
      rows.push(['Reserve', 'niet van toepassing bij een paneel', true]);
    }

    if (r.adhesive.packages > 0) {
      rows.push(['Lijm', r.adhesive.text]);
      rows.push(['Dekking lijm', 'dekt ' + nl(r.adhesive.total_coverage, 0) + ' m², nodig ' + nl(r.net_m2) + ' m²', true]);
      var sizes = this.glueVariants.map(function (v) { return v.kg; }).sort(function (a, b) { return a - b; });
      if (this.settings.show_glue_sizes !== false && sizes.length > 1) {
        var last = sizes.pop();
        rows.push([
          'Verkrijgbaar in',
          'verpakkingen van ' + sizes.map(function (k) { return k + ' kg'; }).join(', ') + ' en ' + last + ' kg',
          true
        ]);
      }
    }

    var head =
      '<div class="bcalc__headline">' +
        '<span class="bcalc__headline-num">' + r.units_recommended + '</span>' +
        '<span class="bcalc__headline-unit">' + esc(unit) + '</span>' +
        '<span class="bcalc__headline-note">' + esc(this.product.title || '') + '</span>' +
      '</div>';

    var body = '<ul class="bcalc__rows">' + rows.map(function (row) {
      return '<li class="bcalc__row' + (row[2] ? ' bcalc__row--sub' : '') + '">' +
        '<span class="bcalc__row-key">' + esc(row[0]) + '</span>' +
        '<span class="bcalc__row-val">' + esc(row[1]) + '</span></li>';
    }).join('') + '</ul>';

    host.innerHTML = head + body + this.cartHtml();
  };

  Calculator.prototype.cartTarget = function () {
    var variants = this.product.variants || [];
    var selected = null;
    for (var i = 0; i < variants.length; i++) {
      if (variants[i].id === this.product.selected_variant_id && !SAMPLE_RX.test(variants[i].title)) {
        selected = variants[i];
        break;
      }
    }
    if (!selected) {
      for (var j = 0; j < variants.length; j++) {
        if (!SAMPLE_RX.test(variants[j].title) && variants[j].available) { selected = variants[j]; break; }
      }
    }
    if (!selected) {
      for (var k = 0; k < variants.length; k++) {
        if (!SAMPLE_RX.test(variants[k].title)) { selected = variants[k]; break; }
      }
    }
    return selected;
  };

  Calculator.prototype.cartHtml = function () {
    var r = this.result;
    var target = this.cartTarget();
    var glueLines = this.glueLines();
    var kit = this.cfg.kit;
    var extras = [];

    if (glueLines.length) {
      extras.push(
        '<li class="bcalc__extra"><input type="checkbox" id="bc-glue" data-extra="glue"' + (this.extras.glue ? ' checked' : '') + '>' +
        '<label for="bc-glue">' + esc((this.cfg.glue && this.cfg.glue.title) || 'Behanglijm') +
        '<span class="bcalc__extra-note">' + esc(r.adhesive.text) + ', genoeg voor ' + nl(r.adhesive.total_coverage, 0) + ' m²</span></label></li>'
      );
    }
    if (kit && kit.variant_id) {
      extras.push(
        '<li class="bcalc__extra"><input type="checkbox" id="bc-kit" data-extra="kit"' + (this.extras.kit ? ' checked' : '') + '>' +
        '<label for="bc-kit">' + esc(kit.title || 'Verwerkingspakket') +
        '<span class="bcalc__extra-note">Kwast, roller, snijmes en lijmbak, een per klus</span></label></li>'
      );
    }

    var qtyLabel = r.units_recommended + ' ' + (r.units_recommended === 1 ? r.unit : r.unit_plural);
    var losseExtras = !target && (glueLines.length || (kit && kit.variant_id));
    var disabled = (!target && !losseExtras) || this.busy;
    var sample = this.sampleTarget();

    var actions = [];
    if (this.settings.show_share !== false) {
      actions.push('<button type="button" class="bcalc__action" data-copy-link>Link kopiëren</button>');
      actions.push('<button type="button" class="bcalc__action" data-print>Opslaan als pdf of printen</button>');
    }
    if (this.restored) {
      actions.push('<button type="button" class="bcalc__action" data-forget>Bewaarde maten wissen</button>');
    }

    return '' +
      '<div class="bcalc__cart">' +
        (extras.length ? '<ul class="bcalc__extras">' + extras.join('') + '</ul>' : '') +
        '<button type="button" class="bcalc__button" data-add-cart' + (disabled ? ' disabled' : '') + '>' +
          (this.busy
            ? 'Bezig'
            : (target
                ? 'Alles in de winkelwagen, ' + esc(qtyLabel)
                : 'Lijm en pakket in de winkelwagen')) +
        '</button>' +
        (sample
          ? '<button type="button" class="bcalc__button bcalc__button--ghost" data-add-sample>' +
              esc(this.settings.sample_label || 'Eerst een behangstaal bestellen') +
            '</button>'
          : '') +
        '<p class="bcalc__cart-msg" data-cart-msg>' +
          (target
            ? ''
            : (this.product.manual
                ? 'Je hebt de maten zelf ingevuld, dus er hangt geen behang aan deze berekening. Zoek het behang op om het te bestellen, of vraag hieronder een offerte aan.'
                : 'Dit product is niet los te bestellen. Neem contact op met LAB.')) +
        '</p>' +
        (actions.length ? '<div class="bcalc__actions">' + actions.join('') + '</div>' : '') +
      '</div>';
  };

  // De variant met staal, sample of monster in de titel.
  Calculator.prototype.sampleTarget = function () {
    if (this.settings.show_sample === false) return null;
    var found = null;
    (this.product.variants || []).forEach(function (v) {
      if (!found && SAMPLE_RX.test(v.title) && v.available !== false) found = v;
    });
    return found;
  };

  Calculator.prototype.addSample = function () {
    var sample = this.sampleTarget();
    if (!sample || this.busy) return;
    var self = this;
    this.postCart([{ id: sample.id, quantity: 1 }], 'Behangstaal toegevoegd aan je winkelwagen.');
  };

  /* ---------------- LAB Projects ---------------- */

  /* ---------------- LAB Projects, offerte per mail ---------------- */

  // LAB Projects werkt met vakmensen, dus de aanvraag rekent altijd op dit profiel.
  var PROJECTS_PROFILE = 'pro';

  // De velden die LAB Projects nodig heeft om een offerte te kunnen maken.
  var CONTACT_FIELDS = [
    { key: 'naam', label: 'Naam', type: 'text', required: true, autocomplete: 'name', span: 2 },
    { key: 'adres', label: 'Straat en huisnummer', type: 'text', required: true, autocomplete: 'street-address', span: 2 },
    { key: 'postcode', label: 'Postcode', type: 'text', required: true, autocomplete: 'postal-code' },
    { key: 'woonplaats', label: 'Woonplaats', type: 'text', required: true, autocomplete: 'address-level2' },
    { key: 'telefoon', label: 'Telefoonnummer', type: 'tel', required: true, autocomplete: 'tel' },
    { key: 'email', label: 'E-mailadres', type: 'email', required: true, autocomplete: 'email' },
    {
      key: 'termijn',
      label: 'Termijn uitvoering',
      type: 'select',
      required: true,
      options: [
        '', 'Zo snel mogelijk', 'Binnen 1 maand', 'Over 1 tot 3 maanden',
        'Over 3 tot 6 maanden', 'Later dan 6 maanden', 'Weet ik nog niet'
      ],
      span: 2
    },
    { key: 'locatie', label: 'Adres van de klus, als dat een ander adres is', mail: 'Adres van de klus', type: 'text', span: 2 },
    { key: 'opmerking', label: 'Bijzonderheden', type: 'textarea', span: 2 }
  ];

  Calculator.prototype.projectsMail = function () {
    var s = this.settings;
    if (s.show_projects === false) return '';
    return s.projects_email || 'projecten@labcolourtheworld.com';
  };

  Calculator.prototype.missingContact = function () {
    var self = this;
    return CONTACT_FIELDS.filter(function (f) {
      return f.required && !String(self.contact[f.key] || '').trim();
    });
  };

  // De hele aanvraag als tekst: eerst wie het is, dan wat er gerekend is.
  Calculator.prototype.mailBody = function () {
    var self = this;
    // LAB Projects laat het werk door een vakman doen, dus de aanvraag gaat op
    // dat profiel, ook als de klant zelf iets anders koos.
    var bundle = this.computeFor(PROJECTS_PROFILE);
    var lines = [];
    lines.push('Hallo LAB Projects,');
    lines.push('');
    lines.push('Ik wil graag een vrijblijvende offerte voor het behangen. Hieronder mijn gegevens en de berekening uit de behangcalculator.');
    lines.push('');
    lines.push('MIJN GEGEVENS');
    CONTACT_FIELDS.forEach(function (f) {
      var v = String(self.contact[f.key] || '').trim();
      // Een leeg veld dat niet verplicht is hoort niet in de mail.
      if (!v && !f.required) return;
      lines.push((f.mail || f.label) + ': ' + v);
    });
    lines.push('');
    lines.push(this.summaryText(bundle));
    lines.push('');
    lines.push('Deze berekening is gemaakt met het profiel ' + bundle.profile.label +
      ', omdat LAB Projects het werk uitvoert.');
    lines.push('');
    lines.push('Met vriendelijke groet,');
    lines.push(String(this.contact.naam || '').trim());
    return lines.join('\n');
  };

  Calculator.prototype.mailHref = function () {
    var to = this.projectsMail();
    if (!to) return '';
    var s = this.settings;
    var subject = (s.projects_subject || 'Offerteaanvraag behang') +
      (this.product.title ? ', ' + this.product.title : '');
    return 'mailto:' + to +
      '?subject=' + encodeURIComponent(subject) +
      '&body=' + encodeURIComponent(this.mailBody());
  };

  Calculator.prototype.projectsHtml = function () {
    var s = this.settings;
    var to = this.projectsMail();
    if (!to) return '';

    return '' +
      '<div class="bcalc__projects">' +
        '<div class="bcalc__projects-text">' +
          '<strong>' + esc(s.projects_title || 'Liever alles uit handen geven?') + '</strong>' +
          (s.projects_intro ? '<span>' + s.projects_intro + '</span>' : '') +
        '</div>' +
        '<button type="button" class="bcalc__button bcalc__button--ghost" data-projects>' +
          esc(s.projects_label || 'Vrijblijvend offerte aanvragen') +
        '</button>' +
        '<div class="bcalc__offerte bcalc__hidden" data-offerte-form></div>' +
      '</div>';
  };

  Calculator.prototype.toggleProjects = function () {
    this.projectsOpen = !this.projectsOpen;
    var box = this.host.querySelector('[data-offerte-form]');
    var btn = this.host.querySelector('[data-projects]');
    if (!box) return;
    box.classList.toggle('bcalc__hidden', !this.projectsOpen);
    if (btn) {
      btn.textContent = this.projectsOpen
        ? 'Aanvraag dichtklappen'
        : (this.settings.projects_label || 'Vrijblijvend offerte aanvragen');
    }
    if (this.projectsOpen) {
      if (!box.innerHTML) this.renderOfferteForm();
      this.refreshMail();
      var first = box.querySelector('[data-contact]');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); } }
    }
  };

  Calculator.prototype.renderOfferteForm = function () {
    var self = this;
    var box = this.host.querySelector('[data-offerte-form]');
    if (!box) return;

    var fields = CONTACT_FIELDS.map(function (f) {
      var id = 'bc-contact-' + f.key;
      var val = esc(self.contact[f.key] || '');
      var control;
      if (f.type === 'select') {
        control = '<select id="' + id + '" data-contact="' + f.key + '">' +
          f.options.map(function (o) {
            return '<option value="' + esc(o) + '"' + (o === (self.contact[f.key] || '') ? ' selected' : '') + '>' +
              esc(o || 'Maak een keuze') + '</option>';
          }).join('') + '</select>';
      } else if (f.type === 'textarea') {
        control = '<textarea id="' + id + '" data-contact="' + f.key + '" rows="3">' + val + '</textarea>';
      } else {
        control = '<input type="' + f.type + '" id="' + id + '" data-contact="' + f.key + '" value="' + val + '"' +
          (f.autocomplete ? ' autocomplete="' + f.autocomplete + '"' : '') + '>';
      }
      return '<div class="bcalc__field' + (f.span === 2 ? ' bcalc__field--wide' : '') + '">' +
        '<label class="bcalc__label" for="' + id + '">' + esc(f.label) + (f.required ? ' *' : '') + '</label>' +
        control + '</div>';
    }).join('');

    box.innerHTML =
      '<div class="bcalc__offerte-grid">' + fields + '</div>' +
      '<p class="bcalc__offerte-note" data-projects-profile></p>' +
      '<a class="bcalc__button" href="#" data-mail-link>Aanvraag versturen</a>' +
      '<p class="bcalc__offerte-note" data-mail-note></p>';
  };

  // De mailtekst en de knop lopen mee met wat er is ingevuld.
  Calculator.prototype.refreshMail = function () {
    var link = this.host.querySelector('[data-mail-link]');
    var note = this.host.querySelector('[data-mail-note]');
    if (!link) return;

    // Laat zien waarmee de aanvraag rekent, want dat kan afwijken van wat de
    // klant hierboven voor zichzelf koos.
    var profNote = this.host.querySelector('[data-projects-profile]');
    if (profNote) {
      var bundle = this.computeFor(PROJECTS_PROFILE);
      var eigen = this.result;
      var zelfde = !eigen || !eigen.valid || !bundle.result.valid ||
        eigen.units_recommended === bundle.result.units_recommended;
      var advies = bundle.result.valid
        ? bundle.result.units_recommended + ' ' +
          (bundle.result.units_recommended === 1 ? bundle.result.unit : bundle.result.unit_plural)
        : '';
      profNote.textContent = 'LAB Projects werkt met vakmensen, dus de aanvraag rekent met het profiel ' +
        bundle.profile.label + ': ' + nl(bundle.profile.waste * 100, 0) + ' cm snijverlies en ' +
        bundle.profile.buffer + ' procent reserve.' +
        (advies ? ' Dat komt uit op ' + advies + (zelfde ? '.' : ', dus anders dan hierboven.') : '');
    }

    var missing = this.missingContact();
    var to = this.projectsMail();

    if (missing.length) {
      link.setAttribute('href', '#');
      link.setAttribute('aria-disabled', 'true');
      link.classList.add('bcalc__button--off');
      if (note) {
        note.innerHTML = 'Vul nog in: ' + esc(missing.map(function (f) { return f.label.toLowerCase(); }).join(', ')) + '.';
      }
    } else {
      link.setAttribute('href', this.mailHref());
      link.removeAttribute('aria-disabled');
      link.classList.remove('bcalc__button--off');
      if (note) {
        note.innerHTML = 'Je mailprogramma opent met alles er al in, gericht aan ' + esc(to) + '. ' +
          'Controleer het en verstuur. ' +
          '<button type="button" class="bcalc__action" data-mail-copy>Tekst kopiëren</button>' +
          (this.settings.projects_url
            ? ' <a class="bcalc__action" href="' + esc(this.settings.projects_url) + '" target="_blank" rel="noopener">Meer over LAB Projects</a>'
            : '');
      }
    }
  };

  Calculator.prototype.copyMail = function (btn) {
    var text = this.mailBody();
    var was = btn ? btn.textContent : '';
    var done = function (ok) {
      if (!btn) return;
      btn.textContent = ok ? 'Gekopieerd' : 'Kopiëren lukte niet';
      window.setTimeout(function () { btn.textContent = was; }, 2200);
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(text).then(function () { done(true); }, function () { done(false); });
        return;
      }
    } catch (e) { /* terugval hieronder */ }
    try {
      var ta = document.createElement('textarea');
      ta.value = text;
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      done(ok);
    } catch (e2) { done(false); }
  };

  Calculator.prototype.wallParam = function () {
    return this.walls
      .filter(function (w) { return w.width && w.height; })
      .map(function (w) {
        return w.width + 'x' + w.height;
      })
      .join(',');
  };

  // Rekent de hele klus door met een ander profiel, zonder de keuze van de klant
  // aan te tasten. LAB Projects werkt met vakmensen, dus de offerteaanvraag gaat
  // altijd op het profiel Vakman.
  Calculator.prototype.computeFor = function (profileKey) {
    var pr = CORE.PROFILES[profileKey] || this.profile();
    var spec = this.buildSpec(pr);
    var res = CORE.calculate(this.walls, spec, {
      buffer: pr.buffer,
      extra_min: pr.extra_min,
      lm_step: parseFloat(this.settings.lm_step) || 1,
      glue_packages: this.gluePackages()
    });
    return { profile: pr, spec: spec, result: res };
  };

  Calculator.prototype.summaryText = function (bundle) {
    var r = bundle ? bundle.result : this.result;
    var spec = bundle ? bundle.spec : this.spec;
    var pr = bundle ? bundle.profile : this.profile();
    var lines = [];
    lines.push('BEREKENING UIT DE BEHANGCALCULATOR');
    lines.push('Product: ' + (this.product.title || ''));
    if (spec.mode === 'panel' || spec.mode === 'tile') {
      lines.push('Formaat: ' + nl(spec.panel_width * 100, 0) + ' x ' + nl(spec.panel_height * 100, 0) + ' cm');
    } else {
      lines.push('Baanbreedte: ' + nl(spec.roll_width * 100, 0) + ' cm' +
        (spec.mode === 'roll' ? ', rol ' + nl(spec.roll_length) + ' m' : ', per lopende meter'));
      lines.push('Aanzet: ' + CORE.PATTERN_LABEL[spec.pattern_type] +
        (spec.repeat ? ' ' + nl(spec.repeat * 100, 0) + ' cm' : ''));
    }
    lines.push('');
    this.walls.forEach(function (w, i) {
      if (!w.width || !w.height) return;
      lines.push('Muur ' + (i + 1) + ': ' + nl(w.width) + ' x ' + nl(w.height) + ' m');
    });
    if (r && r.valid) {
      lines.push('');
      lines.push('Oppervlak: ' + nl(r.net_m2) + ' m2');
      lines.push('Aantal banen: ' + r.strips + (r.extra_strips ? ' plus ' + r.extra_strips + ' reserve' : ''));
      if (r.strips_per_roll > 0) {
        lines.push('Banen per rol: ' + r.strips_per_roll +
          (r.short_last_gain ? ' (laatste baan ' + nl(r.cut_last) + ' m in plaats van ' + nl(r.cut_max) + ' m)' : ''));
      }
      lines.push('Advies: ' + r.units_recommended + ' ' + (r.units_recommended === 1 ? r.unit : r.unit_plural));
      if (r.adhesive.packages > 0) lines.push('Lijm: ' + r.adhesive.text);
      lines.push('Profiel: ' + pr.label + ', ' + nl(pr.waste * 100, 0) + ' cm snijverlies en ' + pr.buffer + ' procent reserve');
    }
    return lines.join('\n');
  };

  /* ---------------- bewaren, delen, printen ---------------- */

  Calculator.prototype.shareUrl = function () {
    var base = window.location.origin + window.location.pathname;
    var p = new URLSearchParams();
    var walls = this.wallParam();
    if (walls) p.set('muren', walls);
    p.set('profiel', this.profileKey);
    if (this.product.selected_variant_id) p.set('variant', this.product.selected_variant_id);
    return base + '?' + p.toString();
  };

  Calculator.prototype.copyLink = function (btn) {
    var url = this.shareUrl();
    var done = function (ok) {
      if (!btn) return;
      var was = btn.textContent;
      btn.textContent = ok ? 'Link gekopieerd' : 'Kopiëren lukte niet';
      window.setTimeout(function () { btn.textContent = was; }, 2200);
    };
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(function () { done(true); }, function () { done(false); });
        return;
      }
    } catch (e) { /* terugval hieronder */ }
    // Oudere browsers: even een veld maken en kopiëren.
    try {
      var ta = document.createElement('textarea');
      ta.value = url;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = document.execCommand('copy');
      document.body.removeChild(ta);
      done(ok);
    } catch (e2) { done(false); }
  };

  // Bouwt het document dat de klant print of als pdf bewaart. Zelfde opmaak als
  // de webshop: inkt op warm gebroken wit, kapitalen met ruime letterafstand.
  Calculator.prototype.printHtml = function () {
    var r = this.result;
    var spec = this.spec;
    var s = this.settings;
    var self = this;

    function line(key, val, strong) {
      return '<div class="bcalc-print__line' + (strong ? ' bcalc-print__line--strong' : '') + '">' +
        '<span>' + esc(key) + '</span><span>' + esc(val) + '</span></div>';
    }

    // ---- kop met logo en titel ----
    var logo = s.logo
      ? '<img class="bcalc-print__logo" src="' + esc(s.logo) + '" alt="">'
      : '<span class="bcalc-print__wordmark">LAB COLOUR THE WORLD</span>';

    var datum = '';
    try {
      datum = new Date().toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { datum = ''; }

    // ---- product ----
    var kenmerken = [];
    if (spec.mode === 'panel' || spec.mode === 'tile') {
      kenmerken.push(CORE.MODE_LABEL[spec.mode]);
      if (spec.panel_width) kenmerken.push('breedte ' + nl(spec.panel_width * 100, 0) + ' cm');
      if (spec.panel_height) kenmerken.push('hoogte ' + nl(spec.panel_height * 100, 0) + ' cm');
    } else {
      kenmerken.push(CORE.MODE_LABEL[spec.mode]);
      if (spec.roll_width) kenmerken.push('baanbreedte ' + nl(spec.roll_width * 100, 0) + ' cm');
      if (spec.mode === 'roll' && spec.roll_length) kenmerken.push('rol ' + nl(spec.roll_length) + ' m');
      kenmerken.push((CORE.PATTERN_LABEL[spec.pattern_type] || '').toLowerCase() +
        (spec.repeat ? ' ' + nl(spec.repeat * 100, 0) + ' cm' : ''));
    }

    var beeld = s.product_image
      ? '<div class="bcalc-print__thumb"><img src="' + esc(s.product_image) + '" alt=""></div>'
      : '';

    // ---- advies ----
    var advies = r.units_recommended + ' ' + (r.units_recommended === 1 ? r.unit : r.unit_plural);
    var erbij = [];
    if (r.adhesive.packages > 0) erbij.push(r.adhesive.text + ' lijm');
    if (this.extras.kit && this.cfg.kit && this.cfg.kit.variant_id) erbij.push('1 verwerkingspakket');

    // ---- muren ----
    var muren = '';
    this.walls.forEach(function (w, i) {
      if (!w.width || !w.height) return;
      muren += line('Muur ' + (i + 1) + '  ·  ' + nl(w.width) + ' bij ' + nl(w.height) + ' m',
        nl(w.width * w.height) + ' m²');
    });
    muren += line('Totaal oppervlak', nl(r.net_m2) + ' m²', true);

    // ---- berekening ----
    var details = [];
    if (spec.mode === 'panel' || spec.mode === 'tile') {
      details.push(['Aantal banen', String(r.strips)]);
    } else {
      details.push(['Aantal banen', String(r.strips)]);
      details.push(['Baanlengte', r.cut_lengths.map(function (c) { return nl(c); }).join(' en ') + ' m']);
      details.push(['Over voor uitlijnen', (r.trim_min === r.trim_max
        ? nl(r.trim_min * 100, 0)
        : nl(r.trim_min * 100, 0) + ' tot ' + nl(r.trim_max * 100, 0)) + ' cm per baan']);
      details.push(['Te snijden lengte', nl(r.total_length_m) + ' m']);
      if (spec.mode === 'roll' && r.strips_per_roll > 0) {
        details.push(['Banen per rol', String(r.strips_per_roll)]);
        if (r.short_last_gain) {
          details.push(['Laatste baan per rol', nl(r.cut_last) + ' m in plaats van ' + nl(r.cut_max) + ' m']);
        }
      }
    }
    if (r.extra_strips > 0) {
      details.push(['Reserve', r.extra_strips + (r.extra_strips === 1 ? ' extra baan' : ' extra banen')]);
    }
    if (r.adhesive.packages > 0) {
      details.push(['Lijm', r.adhesive.text]);
      details.push(['Dekking lijm', nl(r.adhesive.total_coverage, 0) + ' m²']);
    }

    var pr = this.profile();

    return '' +
      '<div class="bcalc-print__sheet">' +
        '<header class="bcalc-print__head">' +
          logo +
          '<span class="bcalc-print__kicker">Behangberekening</span>' +
        '</header>' +

        '<section class="bcalc-print__product">' +
          beeld +
          '<div>' +
            '<h1>' + esc(this.product.title || '') + '</h1>' +
            (this.product.vendor ? '<p class="bcalc-print__vendor">' + esc(this.product.vendor) + '</p>' : '') +
            '<p class="bcalc-print__specs">' + esc(kenmerken.filter(Boolean).join('  ·  ')) + '</p>' +
          '</div>' +
        '</section>' +

        '<section class="bcalc-print__advice">' +
          '<span class="bcalc-print__advice-num">' + esc(advies) + '</span>' +
          (erbij.length ? '<span class="bcalc-print__advice-sub">plus ' + esc(erbij.join(' en ')) + '</span>' : '') +
        '</section>' +

        '<section class="bcalc-print__block">' +
          '<h2>Muren</h2>' + muren +
        '</section>' +

        '<section class="bcalc-print__block">' +
          '<h2>Berekening</h2>' +
          '<div class="bcalc-print__grid">' +
            details.map(function (d) { return line(d[0], d[1]); }).join('') +
          '</div>' +
        '</section>' +

        '<section class="bcalc-print__block">' +
          '<h2>Uitgangspunten</h2>' +
          '<p class="bcalc-print__note">' + esc(pr.label) + ': ' + nl(pr.waste * 100, 0) +
            ' cm snijverlies per baan en ' + pr.buffer + ' procent reserve.' +
            (spec.mode === 'roll' ? ' Elke baan komt in een stuk uit een rol.' : '') +
          '</p>' +
          (s.caution ? '<div class="bcalc-print__note">' + s.caution + '</div>' : '') +
          '<p class="bcalc-print__note">De uitkomst is een advies. Meet je muren twee keer en houd bij een schuine wand of een groot patroon rekening met extra verlies.</p>' +
        '</section>' +

        '<footer class="bcalc-print__foot">' +
          '<span>labcolourtheworld.com</span>' +
          '<span>' + esc(datum) + '</span>' +
        '</footer>' +
      '</div>';
  };

  Calculator.prototype.print = function () {
    var r = this.result;
    if (!r || !r.valid) return;

    var old = document.querySelector('.bcalc-print');
    if (old) old.parentNode.removeChild(old);

    var box = document.createElement('div');
    box.className = 'bcalc-print';
    box.innerHTML = this.printHtml();
    document.body.appendChild(box);

    // Wachten tot de afbeeldingen er zijn, anders print hij lege vlakken.
    var images = Array.prototype.slice.call(box.querySelectorAll('img'));
    var pending = images.filter(function (i) { return !i.complete; });
    var fired = false;
    function go() {
      if (fired) return;
      fired = true;
      window.print();
    }
    if (!pending.length) {
      window.setTimeout(go, 60);
      return;
    }
    var left = pending.length;
    pending.forEach(function (img) {
      var done = function () { left--; if (left <= 0) go(); };
      img.addEventListener('load', done);
      img.addEventListener('error', done);
    });
    window.setTimeout(go, 2500);
  };

  Calculator.prototype.storageKey = function () {
    return 'bcalc:' + (this.product.id || 'onbekend');
  };

  Calculator.prototype.save = function () {
    if (this.settings.remember === false) return;
    try {
      window.localStorage.setItem(this.storageKey(), JSON.stringify({
        walls: this.walls,
        profiel: this.profileKey,
        override: this.override,
        ts: 1
      }));
    } catch (e) { /* privacymodus of vol, dan gewoon niet bewaren */ }
  };

  Calculator.prototype.restore = function () {
    if (this.settings.remember === false) return false;
    try {
      var raw = window.localStorage.getItem(this.storageKey());
      if (!raw) return false;
      var data = JSON.parse(raw);
      if (!data || !data.walls || !data.walls.length) return false;
      this.walls = data.walls;
      if (CORE.PROFILES[data.profiel]) this.profileKey = data.profiel;
      if (data.override) this.override = data.override;
      return true;
    } catch (e) { return false; }
  };

  Calculator.prototype.forget = function () {
    try { window.localStorage.removeItem(this.storageKey()); } catch (e) { /* niets */ }
    this.walls = [{ width: '', height: '' }];
    this.override = {};
    this.restored = false;
    this.renderWalls();
    this.update();
  };

  Calculator.prototype.gluePackages = function () {
    return this.glueVariants.map(function (v) { return { size: v.kg, price: v.price }; });
  };

  Calculator.prototype.glueLines = function () {
    if (!this.result || !this.glueVariants.length) return [];
    var pkg = CORE.adhesivePackaging(this.result.net_m2, this.gluePackages(), this.spec.coverage_per_kg);
    var self = this;
    return pkg.lines.map(function (line) {
      var match = null;
      self.glueVariants.forEach(function (v) { if (!match && v.kg === line.size) match = v; });
      return match ? { id: match.id, quantity: line.count, title: match.title } : null;
    }).filter(Boolean);
  };

  /* ---------------- winkelwagen ---------------- */

  Calculator.prototype.addToCart = function () {
    var r = this.result;
    var target = this.cartTarget();
    if (!r || this.busy) return;

    var self = this;
    var msg = this.host.querySelector('[data-cart-msg]');
    var items = [];

    var props = {};
    props['Berekend met'] = 'LAB behangcalculator';
    props['Oppervlak'] = nl(r.net_m2) + ' m²';
    props['Aantal banen'] = String(r.strips);

    if (target) items.push({ id: target.id, quantity: r.units_recommended, properties: props });

    if (this.extras.glue) {
      this.glueLines().forEach(function (line) {
        items.push({ id: line.id, quantity: line.quantity });
      });
    }
    if (this.extras.kit && this.cfg.kit && this.cfg.kit.variant_id) {
      items.push({ id: this.cfg.kit.variant_id, quantity: 1 });
    }

    this.postCart(items, 'Toegevoegd aan je winkelwagen.');
  };

  Calculator.prototype.postCart = function (items, okText) {
    if (!items.length || this.busy) return;
    var self = this;
    this.busy = true;
    this.renderResult();

    var root = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/$/, '');

    fetch(root + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (res) {
        if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || d.message || 'Toevoegen mislukt'); });
        return res.json();
      })
      .then(function () {
        self.busy = false;
        if (self.settings.redirect_to_cart === false) {
          self.renderResult();
          var m = self.host.querySelector('[data-cart-msg]');
          if (m) m.innerHTML = esc(okText) + ' <a href="' + root + '/cart">Naar de winkelwagen</a>';
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (typeof self.onCartSuccess === 'function') self.onCartSuccess();
        } else {
          window.location.href = root + '/cart';
        }
      })
      .catch(function (err) {
        self.busy = false;
        self.renderResult();
        var m = self.host.querySelector('[data-cart-msg]');
        if (m) {
          m.textContent = 'Toevoegen lukte niet: ' + err.message;
          m.classList.add('bcalc__cart-msg--error');
        }
      });
  };

  /* ---------------- deelbare link ---------------- */

  Calculator.prototype.restoreFromUrl = function () {
    var used = false;
    try {
      var params = new URLSearchParams(window.location.search);
      var raw = params.get('muren');
      if (raw) {
        var parsed = raw.split(',').map(function (part) {
          var wh = (part.split(':')[0] || '').split('x');
          return { width: parseFloat(wh[0]) || '', height: parseFloat(wh[1]) || '' };
        }).filter(function (w) { return w.width || w.height; });
        if (parsed.length) { this.walls = parsed; used = true; }
      }
      var prof = params.get('profiel');
      if (prof && CORE.PROFILES[prof]) { this.profileKey = prof; used = true; }
    } catch (e) { /* een kapotte link mag de calculator niet blokkeren */ }
    return used;
  };

  /* ---------------- render en update ---------------- */

  Calculator.prototype.render = function () {
    this.spec = this.buildSpec();
    this.renderChips();
    this.renderSpec();
    this.renderWalls();
    this.renderProfiles();
    this.update();
  };

  Calculator.prototype.update = function () {
    this.spec = this.buildSpec();
    this.result = CORE.calculate(this.walls, this.spec, {
      buffer: this.profile().buffer,
      extra_min: this.profile().extra_min,
      lm_step: parseFloat(this.settings.lm_step) || 1,
      glue_packages: this.gluePackages()
    });
    this.renderAreas();
    this.renderChips();
    this.renderNotices();
    this.renderResult();
    this.refreshProfiles();
    if (this.projectsOpen) this.refreshMail();

    var self = this;
    window.clearTimeout(this._saveTimer);
    this._saveTimer = window.setTimeout(function () { self.save(); }, 500);
  };

  // Wisselt de klant van variant op de productpagina, dan gaat de winkelwagen
  // mee. De namen van deze events verschillen per thema, daarom meerdere.
  Calculator.prototype.watchVariant = function () {
    var self = this;
    ['variant:changed', 'variant:change', 'variantChange'].forEach(function (name) {
      document.addEventListener(name, function (e) {
        var v = e && e.detail && (e.detail.variant || e.detail);
        if (!v || !v.id) return;
        self.product.selected_variant_id = v.id;
        self.renderResult();
      });
    });
  };

  /* ============================================================
     Pop-up en de knop bij toevoegen aan winkelwagen
     ============================================================ */

  var RULER_ICON =
    '<svg class="bcalc-trigger__icon" viewBox="0 0 20 20" width="17" height="17" aria-hidden="true" focusable="false">' +
      '<rect x="1.4" y="6" width="17.2" height="8" rx="1" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
      '<path d="M5.6 6v2.6M8.4 6v4M11.2 6v2.6M14 6v4M16.8 6v2.6" fill="none" stroke="currentColor" stroke-width="1.3"/>' +
    '</svg>';

  // Zoekt de knop Toevoegen aan winkelwagen van het product zelf. Op een
  // productpagina staan al gauw tien formulieren naar /cart/add: elke
  // productkaart in een carrousel heeft er een, en er is een verborgen
  // formulier voor snelkoop. Daarom niet de eerste de beste pakken maar
  // punten geven en de beste kiezen.
  //
  // Let op: dit thema gebruikt nergens name="add", de knop is een gewone
  // button met type submit. Dat kan per thema verschillen, dus allebei.
  function findAddButton() {
    var forms = Array.prototype.slice.call(document.querySelectorAll('form[action*="/cart/add"]'));
    var beste = null;
    var besteScore = -1;

    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      if (form.closest('template')) continue;
      if (form.closest('.bcalc-modal')) continue;
      if (form.closest('[data-bcalc-skip]')) continue;

      var btn = form.querySelector('[name="add"]') ||
                form.querySelector('button[type="submit"]:not([name="checkout"]), input[type="submit"]');
      if (!btn) continue;
      // Onzichtbaar betekent een verborgen formulier of een kaart buiten beeld.
      if (btn.offsetParent === null && btn.getClientRects().length === 0) continue;

      var score = 0;
      if (btn.closest('buy-buttons, .buy-buttons, .product-form__buttons')) score += 3;
      if (form.closest('product-form, .product-form')) score += 1;
      if (form.closest('.product-info, .product__info, #MainProduct, main, [id*="main"]')) score += 2;
      // Kaarten in een carrousel of snelkoop tellen af.
      if (form.closest('.product-card, .card, [class*="quick"], [class*="carousel"], [class*="slider"]')) score -= 4;
      // Een balk die meescrollt is niet de plek voor onze knop.
      if (btn.closest('[class*="sticky"], product-sticky-bar')) score -= 3;

      if (score > besteScore) { besteScore = score; beste = btn; }
    }
    return beste;
  }

  function Launcher(host, config) {
    this.host = host;
    this.cfg = config || {};
    this.settings = this.cfg.settings || {};
    this.mode = this.settings.display_mode || 'modal';
    this.dialog = null;
    this.calculator = null;
    this.trigger = null;
    this.observer = null;

    if (this.mode === 'inline' || this.mode === 'both') this.mountInline();
    if (this.mode === 'modal' || this.mode === 'both') this.setupModal();
  }

  Launcher.prototype.mountInline = function () {
    var mount = document.createElement('div');
    this.host.appendChild(mount);
    this.inline = new Calculator(mount, this.cfg);
  };

  Launcher.prototype.setupModal = function () {
    this.buildTrigger();
    this.placeTrigger();
    this.watchForm();
  };

  Launcher.prototype.buildTrigger = function () {
    var s = this.settings;
    var label = s.trigger_label || 'Help met uitrekenen';
    var note = s.trigger_note || '';
    var style = s.trigger_style === 'solid' ? ' bcalc-trigger--solid' : '';

    var wrap = document.createElement('div');
    wrap.className = 'bcalc-trigger-wrap';
    wrap.setAttribute('data-bcalc-trigger-wrap', '');
    wrap.innerHTML =
      '<button type="button" class="bcalc-trigger' + style + '" data-bcalc-open>' +
        (s.trigger_icon === false ? '' : RULER_ICON) +
        '<span>' + esc(label) + '</span>' +
      '</button>' +
      (note ? '<p class="bcalc-trigger__note">' + esc(note) + '</p>' : '');

    var self = this;
    wrap.querySelector('[data-bcalc-open]').addEventListener('click', function (e) {
      e.preventDefault();
      self.open();
    });

    this.trigger = wrap;
  };

  Launcher.prototype.placeTrigger = function () {
    if (!this.trigger) return false;
    var where = this.settings.trigger_position || 'before_add';

    // Een achtergebleven knop van een eerdere opbouw weghalen, anders staan
    // er straks twee. Gebeurt in de themabewerker, die secties opnieuw bouwt.
    var self = this;
    Array.prototype.forEach.call(document.querySelectorAll('[data-bcalc-trigger-wrap]'), function (el) {
      if (el !== self.trigger && el.parentNode) el.parentNode.removeChild(el);
    });

    if (where === 'section') {
      this.host.appendChild(this.trigger);
      return true;
    }

    var target = findAddButton();
    if (!target || !target.parentNode) {
      // Geen knop gevonden, dan komt hij op de plek van de section te staan.
      // Beter een knop op een rare plek dan geen knop.
      this.host.appendChild(this.trigger);
      this.placedFallback = true;
      return false;
    }

    if (where === 'after_add') {
      target.parentNode.insertBefore(this.trigger, target.nextSibling);
    } else {
      target.parentNode.insertBefore(this.trigger, target);
    }
    this.placedFallback = false;
    return true;
  };

  // Het thema bouwt het koopblok opnieuw op bij een variantwissel, en de
  // themabewerker doet dat bij elke instelling die je aanpast. Verdwijnt onze
  // knop daarbij, dan zetten we hem terug.
  Launcher.prototype.watchForm = function () {
    var self = this;
    var where = this.settings.trigger_position || 'before_add';
    if (where === 'section') return;

    var recheck = function () {
      if (self.trigger && self.trigger.isConnected && !self.placedFallback) return;
      self.placeTrigger();
    };
    this.recheck = recheck;

    // Belangrijk: de timer niet bij elke wijziging opnieuw starten. In de
    // themabewerker komen wijzigingen vrijwel onafgebroken binnen, en dan
    // wordt het herstellen eindeloos uitgesteld en komt de knop nooit terug.
    // Nu staat er hooguit een controle gepland, die gaat gewoon af.
    this.observer = new MutationObserver(function () {
      if (self._recheck) return;
      self._recheck = window.setTimeout(function () {
        self._recheck = null;
        recheck();
      }, 150);
    });
    this.observer.observe(document.body, { childList: true, subtree: true });

    // Vangnet voor het geval er helemaal geen wijziging voorbijkomt die wij
    // zien. Een controle per seconde die vrijwel altijd meteen klaar is.
    this.timer = window.setInterval(recheck, 1000);

    ['variant:changed', 'variant:change', 'variantChange', 'product:rerender', 'shopify:section:load']
      .forEach(function (name) {
        document.addEventListener(name, function () { window.setTimeout(recheck, 150); });
      });
  };

  Launcher.prototype.buildDialog = function () {
    if (this.dialog) return this.dialog;
    var self = this;
    var title = this.settings.modal_title || this.settings.heading || 'Behangcalculator';

    var dialog = document.createElement('dialog');
    dialog.className = 'bcalc-modal';
    dialog.setAttribute('aria-label', title);
    dialog.innerHTML =
      '<div class="bcalc-modal__inner">' +
        '<div class="bcalc-modal__head">' +
          '<span class="bcalc-modal__title">' + esc(title) + '</span>' +
          '<button type="button" class="bcalc-modal__close" data-bcalc-close aria-label="Sluiten">×</button>' +
        '</div>' +
        '<div class="bcalc-modal__body" data-bcalc-body></div>' +
      '</div>';

    dialog.addEventListener('click', function (e) {
      if (e.target.closest('[data-bcalc-close]')) { self.close(); return; }
      // Klik op de achtergrond, dus buiten het witte vlak, sluit de pop-up.
      if (e.target === dialog) self.close();
    });
    dialog.addEventListener('cancel', function (e) {
      e.preventDefault();
      self.close();
    });

    document.body.appendChild(dialog);
    this.dialog = dialog;

    // De calculator pas opbouwen als de pop-up voor het eerst opengaat.
    var mount = dialog.querySelector('[data-bcalc-body]');
    var cfg = Object.assign({}, this.cfg);
    cfg.settings = Object.assign({}, this.settings, { in_modal: true });
    this.calculator = new Calculator(mount, cfg);
    this.calculator.onCartSuccess = function () {
      window.setTimeout(function () { self.close(); }, 1400);
    };

    return dialog;
  };

  Launcher.prototype.open = function () {
    var dialog = this.buildDialog();
    if (typeof dialog.showModal === 'function' && !dialog.open) {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    document.documentElement.classList.add('bcalc-locked');

    // Meteen in het eerste muurveld staan, dan kan je gelijk typen.
    var first = dialog.querySelector('[data-wall]');
    if (first) {
      try { first.focus({ preventScroll: true }); } catch (e) { first.focus(); }
    }
  };

  Launcher.prototype.close = function () {
    if (!this.dialog) return;
    if (typeof this.dialog.close === 'function' && this.dialog.open) {
      this.dialog.close();
    } else {
      this.dialog.removeAttribute('open');
    }
    document.documentElement.classList.remove('bcalc-locked');
    var btn = this.trigger && this.trigger.querySelector('[data-bcalc-open]');
    if (btn) btn.focus();
  };

  Launcher.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.timer) window.clearInterval(this.timer);
    if (this._recheck) window.clearTimeout(this._recheck);
    if (this.dialog && this.dialog.parentNode) this.dialog.parentNode.removeChild(this.dialog);
    if (this.trigger && this.trigger.parentNode) this.trigger.parentNode.removeChild(this.trigger);
    document.documentElement.classList.remove('bcalc-locked');
  };

  /* ---------------- custom element ---------------- */

  function readConfig(el) {
    var node = el.querySelector('script[type="application/json"]');
    if (!node) return {};
    try { return JSON.parse(node.textContent); } catch (e) { return {}; }
  }

  if (!window.customElements.get('behang-calculator')) {
    window.customElements.define('behang-calculator', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.mounted) return;
        this.dataset.mounted = '1';
        var mount = document.createElement('div');
        this.appendChild(mount);
        this.launcher = new Launcher(mount, readConfig(this));
        // Voor de themabewerker en voor de test: de calculator van de pop-up
        // is er pas na de eerste klik, die van inline meteen.
        this.calculator = this.launcher.inline || null;
      }
      disconnectedCallback() {
        if (this.launcher) this.launcher.destroy();
      }
    });
  }

  window.LABBehangCalcUI = {
    Calculator: Calculator,
    Launcher: Launcher,
    kgFromTitle: kgFromTitle,
    findAddButton: findAddButton
  };
})();